export const LOCAL_KEYS = {
  TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  REMEMBER_ME: "remember_me",
  USER: "user",
  USER_DETAIL: "user_detail",
  ROLE: "role",
  LANGUAGE: "language",
  THEME: "theme",
  IS_AUTHENTICATED: "is_authenticated",
  PERMISSIONS: "user_permissions",
  REALM: "realm",
  SELECTED_DISTRIBUTOR: "selectedDistributor",
  SHOW_DISTRIBUTOR_POPOVER: "show_distributor_popover",
} as const;

export const USER_ROLE = {
  CRMAdmin: "CRMAdmin",
  CRMUser: "CRMUser",
  CustomerAdmin: "CustomerAdmin",
  CustomerUser: "CustomerUser",
  SuperUser: "SuperUser",
  RootrUser: "RootUser",
} as const;

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const QUERY_KEYS = {
  USER: "user",
  PROFILE: "profile",
} as const;

export const AntThemeConfig = {
  token: {
    colorPrimary: "#3867d6",
    borderRadius: 8,
    fontFamily: "Inter, sans-serif",
  },
};

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_CURRENT_PAGE = 0;
export const ALL_START_DATE = "2020-06-01 00:00:00";

export const SORTING_OPTIONS = [
  {
    label: "Ascending",
    value: "asc",
  },
  {
    label: "Descending",
    value: "desc",
  },
];

export const DATE_FILTER_OPTIONS = [
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Yesterday",
    value: "yesterday",
  },
  {
    label: "Last 7 days",
    value: "last7",
  },
  {
    label: "Last 30 days",
    value: "last30",
  },
  {
    label: "All",
    value: "all",
  },
  {
    label: "Custom",
    value: "custom",
  },
];
export const MCC_CONTROL_CUSTOM_STRING = "- Custom";
